import { Grid, Cell } from 'baseui/layout-grid'
import CommonFallback from '@/shared/components/CommonFallback'
import ContractsFilters from './ContractsFilters/ContractsFilters'
import ContractsTable from './ContractsTable/ContractsTable'
import ContractsPagination from './ContractsPagination/ContractsPagination'
import useDashboardV2 from './useDashboardV2'

const DashboardV2 = () => {
  const { isLoading, getContracts, filters, applicationType, usersList, providersList, formInitUrl, t, navigateToV1 } =
    useDashboardV2()

  if (isLoading) {
    return <CommonFallback />
  }

  return (
    <Grid>
      <Cell span={12}>
        <div
          style={{
            marginBottom: '2rem',
            backgroundColor: 'white',
            padding: '1rem',
            borderRadius: '1rem',
            boxShadow: '0 2px 6px rgba(20,96,170,.3)',
            textDecoration: 'underline',
          }}
        >
          <a onClick={navigateToV1}>{t('subscriptionTable:link_to_v1_text')}</a>
        </div>
      </Cell>
      <Cell span={12}>
        <ContractsFilters
          filters={filters}
          providersList={providersList}
          usersList={usersList}
          applicationType={applicationType}
        />
      </Cell>
      <Cell span={12}>
        <ContractsTable businessType={applicationType} getContracts={getContracts} formInitUrl={formInitUrl} />
        <ContractsPagination />
      </Cell>
    </Grid>
  )
}

export default DashboardV2
